import { Languages } from "../langs/langs";

export enum Step {
  NONE=-1,
  
  WEB_CONFIG=1,

  ONBOARD_ACCEPT_TERMS=2,
  ONBOARD_TIPS=3,
  ONBOARD_SCAN_FRONT_ID=4,
  ONBOARD_TURN_DOC=5,
  ONBOARD_SCAN_BACK_ID=6,
  ONBOARD_SUMMARY=7,
  ONBOARD_SELFIE=8,
  ONBOARD_SCAN_FACE=9,
  ONBOARD_PROCESSING=10,

  VISITOR_INFO=100,
  VISITOR_PROCESSING=101,

  FACEONLY_SELFIE=301,
  FACEONLY_SCAN_FACE=302,
  FACEONLY_PROCESSING=303,

  SHOW_ERROR=1000,
}

export enum Check{
  UNCHECKED=0,
  CHECKED=1,
  EMPHASIZED=2
}

export interface OnbordingData {
  tmp: number;
  sec: number;
}

export interface FinishData{
  header: String;
  headerNum: String;
  msgTop: string;
  msgBottom: string;
}

export interface ErrorData{
  header: String;
  headerNum: String;
  msgTop: string;
  msgBottom: string;
  nextStep: Step;
}

export enum VisitorDataConfigVal{
  HIDDEN=1,
  EDITABLE=2,
  READ_ONLY=3,
  OFF=4
}

export interface VisitorDataConfig {
  cfgEmail: VisitorDataConfigVal;
  cfgAge: VisitorDataConfigVal;
  cfgGender: VisitorDataConfigVal;
  cfgGivenNames: VisitorDataConfigVal;
  cfgSurname: VisitorDataConfigVal;
  cfgFullname: VisitorDataConfigVal;
  cfgAddress: VisitorDataConfigVal;
  cfgDateOfBirth: VisitorDataConfigVal;
  cfgPersonalNumber: VisitorDataConfigVal;
  cfgCitizenship: VisitorDataConfigVal;
  cfgNationality: VisitorDataConfigVal;
  cfgDocCountry: VisitorDataConfigVal;
  cfgDocEdition: VisitorDataConfigVal;
  cfgDocType: VisitorDataConfigVal;
  cfgDocIssue: VisitorDataConfigVal;
  cfgDocExpiry: VisitorDataConfigVal;
  cfgDocNumber: VisitorDataConfigVal;
}

export interface VisitorData {
  id: number;
  customId: string;
  id_lang: Languages;
  rnd: number;
  found: boolean;
  email: string;
  age: number;
  gender: string;
  givenNames: string;
  surname: string;
  fullname: string;
  address: string;
  dateOfBirth: string;
  personalNumber: string;
  citizenship: string;
  nationality: string;
  docCountry: string;
  docEdition: string;
  docType: string;
  docIssue: string;
  docExpiry: string;
  docNumber: string;
  banned: boolean;
  bannedListed: boolean;
  faceUrl: string;
}
